<template>
<div style="background-color: #F5F7FA;height:550px;display: flex;
  justify-content: center;">
    <div style="padding: 100px 0;position: relative;">
        <span>是否报警：</span>
        <el-select v-model="tag" placeholder="请选择是否报警" style="width:300px">
          <el-option
              v-for="item in tagValue"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
          </el-option>
        </el-select>
        <el-button :loading="loading" type="primary" @click="submit" style="margin-left:10px">编辑</el-button>
    </div>
</div>

</template>

<script>



import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "PageForDevice",
  data() {
    return {
      userCode: '',
      tag:0,
      tagValue: [{
        value: 0, label: '不提醒'
      }, {
        value: 1, label: '提醒'
      }],
    }
  },
  components: {

  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.getWeiLanInfoDevice();
    },
    closeSelf() {
      this.$emit("closeWeiLanAlarmShow");
    },
    getWeiLanInfoDevice(){
      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Positioning/WeiLanInfoDevice",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode:this.userCode,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              console.log(response.data.data)
              this.tag=response.data.data.weiLanAlert;
              console.log(this.tag)
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    submit(){
      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Positioning/EditIsAlert",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode,
          tag:this.tag
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              console.log(response.data.data)
              this.$emit("closeWeiLanAlarmShow");
              this.$message({type: 'success', message:'编辑成功！'});
            } else if (response.data.error === 1) {
              this.$message({type: 'warning', message: response.data.message});
            }
          }
      )
    },



  },

}


</script>

<style lang="scss" scoped>


</style>